import { Icons } from "@/components/ui";
import {
  Activity,
  Ambulance,
  Baby,
  BookHeart,
  Calendar,
  CircleDollarSign,
  Contact,
  FolderOpen,
  Hospital,
  House,
  type LucideIcon,
  Pill,
  ShieldHalf,
  Slice,
  Syringe,
  TestTube,
  TriangleAlert,
  Trophy,
  Users,
} from "lucide-react";

export interface MedicalRecordSection {
  key: string;
  label: string;
  to: string;
  icon: LucideIcon | typeof Icons.WomensHealthLogo;
}

export const MEDICAL_RECORD_SECTIONS: MedicalRecordSection[] = [
  {
    key: "timeline",
    icon: Calendar,
    label: "Timeline",
    to: "timeline",
  },
  {
    key: "profile",
    icon: House,
    label: "Profile",
    to: "profile",
  },
  {
    key: "vitals",
    icon: Activity,
    label: "Vitals",
    to: "vitals",
  },
  {
    key: "medical-history",
    icon: Hospital,
    label: "Medical History",
    to: "medical-history",
  },
  {
    key: "medications-allergies",
    icon: Pill,
    label: "Medications",
    to: "medications-allergies",
  },
  {
    key: "social-history",
    icon: Users,
    label: "Social History",
    to: "social-history",
  },
  {
    key: "sexual-history",
    icon: BookHeart,
    label: "Sexual History",
    to: "sexual-history",
  },
  {
    key: "family-history",
    icon: Baby,
    label: "Family History",
    to: "family-history",
  },
  {
    key: "womens-health",
    icon: Icons.WomensHealthLogo,
    label: "Women's Health",
    to: "womens-health",
  },
  {
    key: "hospitalizations",
    icon: Ambulance,
    label: "Hospitalizations",
    to: "hospitalizations",
  },
  {
    key: "immunizations",
    icon: Syringe,
    label: "Immunizations",
    to: "immunizations",
  },
  {
    key: "labs",
    icon: TestTube,
    label: "Labs",
    to: "labs",
  },
  {
    key: "surgical-history",
    icon: Slice,
    label: "Surgical History",
    to: "surgical-history",
  },
  {
    key: "health-maintenance",
    icon: ShieldHalf,
    label: "Health Maintenance",
    to: "health-maintenance",
  },
  {
    key: "goals",
    icon: Trophy,
    label: "Goals",
    to: "goals",
  },
  {
    key: "health-insurance",
    icon: CircleDollarSign,
    label: "Health Insurance",
    to: "health-insurance",
  },
  {
    key: "external-care-team",
    icon: Contact,
    label: "External Care Team",
    to: "external-care-team",
  },
  {
    key: "files",
    icon: FolderOpen,
    label: "Files",
    to: "files",
  },
  {
    key: "alerts",
    icon: TriangleAlert,
    label: "Alerts",
    to: "alerts",
  },
];
